import React from 'react'
import {Navigate,Outlet} from 'react-router-dom'
import { useEyeconxStore } from '../store/eyeconxStore'
const PrivateRoutes = () =>{
    const isAuthenticated  = useEyeconxStore(state => state.isAuthenticated)
    const user = useEyeconxStore((state)=>(state.user))
    const isAdminPortalUser =
        user?.clinicType === 'ADMIN' && user?.role === 'ADMIN'
    return(
        isAuthenticated && isAdminPortalUser ? <Outlet/> : <Navigate to="/login"/>
    )
}
export default PrivateRoutes;